import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();

  const getCampaignBreadcrumbs = (pathname) => {
    if (pathname === '/campaigns') {
      return [
        { label: 'Accueil', path: '/sales-overview-dashboard' },
        { label: 'Campagnes', path: '/campaigns' },
      ];
    }
    if (pathname?.startsWith('/campaigns/')) {
      const parts = pathname.split('/').filter(Boolean);
      const crumbs = [
        { label: 'Accueil', path: '/sales-overview-dashboard' },
        { label: 'Campagnes', path: '/campaigns' },
      ];
      if (parts[1] === 'new') {
        crumbs.push({ label: 'Nouvelle campagne', path: pathname });
        return crumbs;
      }
      const campaignId = parts[1];
      if (campaignId && campaignId !== 'new') {
        const campaignBase = `/campaigns/${campaignId}`;
        crumbs.push({ label: 'Campagne', path: `${campaignBase}/products` });
        if (parts[2] === 'products') {
          crumbs.push({ label: 'Produits', path: `${campaignBase}/products` });
        } else if (parts[2] === 'hubup') {
          crumbs.push({ label: 'HubUP', path: `${campaignBase}/hubup` });
        } else if (parts[2] === 'email') {
          crumbs.push({ label: 'Email', path: `${campaignBase}/email` });
          if (parts[3] === 'templates') {
            const tid = parts[4];
            crumbs.push({
              label: tid === 'new' ? 'Nouveau template' : 'Modifier template',
              path: pathname,
            });
          } else if (parts[3] === 'send') {
            crumbs.push({ label: 'Envoyer', path: pathname });
          }
        }
      }
      return crumbs;
    }
    return null;
  };

  const breadcrumbMap = {
    '/sales-overview-dashboard': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: "Vue d\'ensemble", path: '/sales-overview-dashboard' }
    ],
    '/call-performance-analytics': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Performance', path: '/call-performance-analytics' }
    ],
    '/prospect-pipeline-monitor': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Tableau de bord', path: '/prospect-pipeline-monitor' }
    ],
    '/contact-intelligence-hub': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Intelligence contacts', path: '/contact-intelligence-hub' }
    ],
    '/prospect-contact-directory': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Annuaire', path: '/prospect-contact-directory' }
    ],
    '/prospect-contact-directory/import': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Annuaire', path: '/prospect-contact-directory' },
      { label: 'Import CSV', path: '/prospect-contact-directory/import' },
    ],
    '/prospect-contact-directory/search': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Annuaire', path: '/prospect-contact-directory' },
      { label: 'Rechercher des prospects', path: '/prospect-contact-directory/search' },
    ],
    '/team-management': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: "Gestion d'équipe", path: '/team-management' },
    ],
    '/accounts-manage': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Gestion des comptes', path: '/accounts-manage' },
    ],
    '/companies-manage': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Entreprises', path: '/companies-manage' },
    ],
    '/sales-admin': [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
      { label: 'Ventes', path: '/sales-admin' },
    ],
    '/affiliate-tracking': [
      { label: 'Accueil', path: '/' },
      { label: 'Suivi affilié', path: '/affiliate-tracking' },
    ],
  };

  const breadcrumbs =
    getCampaignBreadcrumbs(location?.pathname) ||
    breadcrumbMap?.[location?.pathname] || [
      { label: 'Accueil', path: '/sales-overview-dashboard' },
    ];

  return (
    <nav className="breadcrumb-container" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <span className="breadcrumb-separator">
              <Icon name="ChevronRight" size={16} />
            </span>
          )}
          <div className={`breadcrumb-item ${index === breadcrumbs?.length - 1 ? 'active' : ''}`}>
            {index === breadcrumbs?.length - 1 ? (
              <span>{crumb?.label}</span>
            ) : (
              <Link to={crumb?.path} className="breadcrumb-link">
                {crumb?.label}
              </Link>
            )}
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;